import { Box, Center } from '@chakra-ui/react';
import { useDetailedStatusScrapejobs, useApproveScrapejob, useRejectScrapejob, useSanitizeScrapejob } from 'hooks/queries/useScrapejobs';
import { ProcessStatus } from 'models/types';
import Slider from 'components/Slider/Slider';
import DetailedScrapeJobCard from 'components/Scrapejob/DetailedScrapeJobCard/DetailedScrapeJobCard';
import Loader from 'components/Loader/Loader';
import EmptyState from 'components/EmptyState/EmptyState';

export default function PendingScrapejobsCarousel() {
  const { data: paginatedScrapejobs, isLoading } = useDetailedStatusScrapejobs(ProcessStatus.PENDING);
  const approveMutation = useApproveScrapejob();
  const rejectMutation = useRejectScrapejob();
  const sanitizeMutation = useSanitizeScrapejob();

  const handleApprove = (scrapejobId: string) => {
    approveMutation.mutate({ scrapejob_id: scrapejobId });
  };

  const handleReject = (scrapejobId: string) => {
    rejectMutation.mutate({ scrapejob_id: scrapejobId });
  };

  const handleSanitize = (scrapejobId: string) => {
    sanitizeMutation.mutate({ scrapejob_id: scrapejobId });
  };

  if (isLoading) {
    return (
      <Center p={8}>
        <Loader />
      </Center>
    );
  }

  if (!paginatedScrapejobs?.hasData()) {
    return (
      <Box width="100%">
        <EmptyState
          header="No Pending Scrapejobs"
          description="There are no pending scrapejobs at this time"
          showButton={false}
        />
      </Box>
    );
  }

  // Get up to 5 scrapejobs for the carousel
  const scrapejobs = paginatedScrapejobs.data.slice(0, 5);

  const carouselContent = scrapejobs.map((scrapejob, index) => (
    <Box key={`pending_scrapejob_${scrapejob.id}_${index}`} px={2}>
      <DetailedScrapeJobCard
        scrapejob={scrapejob}
        onApprove={handleApprove}
        onReject={handleReject}
        onSanitize={handleSanitize}
        approveLoading={approveMutation.isPending}
        rejectLoading={rejectMutation.isPending}
        sanitizeLoading={sanitizeMutation.isPending}
        defaultAccordionOpen={false}
      />
    </Box>
  ));

  return (
    <Box width="100%">
      <Slider
        content={carouselContent}
        slidesPerView={1}
        slidesPerMobileView={1}
        pagination={true}
        enableAutoPlay={false}
        itemPadding={0}
      />
    </Box>
  );
}
